// Model
import { Model } from "@mgs/ci2019-common/src/models/model/Model";
import { ConfigSelectionResultDTO } from "./ConfigSelectionResultDTO";

export class ConfigSelectionResult extends Model<ConfigSelectionResultDTO> {
  public klasse!: number;
  public showConfigSelection!: boolean;
  public dates?: { min: string; max: string };

  constructor(initial?: Partial<ConfigSelectionResultDTO>) {
    super();
    this.init(initial);
  }
}
